import { render, staticRenderFns } from "./SkuBundleForm.vue?vue&type=template&id=05f66aa0"
import script from "./SkuBundleForm.vue?vue&type=script&lang=js"
export * from "./SkuBundleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports